import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
//import { useParams } from 'react-router-dom'

import { Message, Panel } from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
import moment from 'moment'
import scrollToComponent from 'react-scroll-to-component'
import PersonalBasicInfoForm from '../../components/forms/personalBasicInfoForm/PersonalBasicInfoForm'
import PersonalBasicInfoView from './PersonalBasicInfoView'
import {
  downlondSubProjectDocument,
  saveProposalGranteeBasicInfo,
  saveSubProjectProposalGranteeBasicInfo,
  updateProposalGranteeBasicInfo,
  updateSubProjectProposalGranteeBasicInfo,
} from '../../redux/actions/proposalGranteeBasicInfo'
import {
  saveProposalResponsinatorBasicInfo,
  saveProposalResponsinatorBasicInfoSubproject,
  updateProposalResponsinatorBasicInfo,
  updateProposalResponsinatorBasicInfoSubproject,
} from '../../redux/actions/proposalResponsinator'
import { startLoading, doneLoading } from '../../utils/loading'
import { getSchemaSidebar, getSchemaSubProjectSidebar } from '../../redux/actions/sidebar'
import ButtonPanel from '../ButtonPanel'
import { downlondDocument } from '../../redux/actions/proposalGranteeBasicInfo'
import { downloadFile, previewFile } from '../../utils/fileUtil'

export default function PersonalBasicInfo({
  honorificOptions,
  schema,
  isEditAll,
  callbackAction = () => {},
  ...props
}) {
  const { type, isEdit, onChangeIsEdit, showCommandButton, isSubProject, offerFundedInfoSchema } = props
  const [section, setSection] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [isError, setIsError] = useState(false)
  const { register, handleSubmit, errors, control, getValues, setValue, setError, clearErrors } =
    useForm()

  const [formSchema, setFormSchema] = useState(schema)
  const dispatch = useDispatch()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')
  const [fileErr, setFileErr] = useState()

  const handleUpdate = async (request, personalId) => {
    startLoading()
    setIsLoading(true)
    setIsError(false)
    try {
      let response
      switch (type) {
        case 'grantee':
          response = isSubProject
            ? await updateSubProjectProposalGranteeBasicInfo(request, projectId, personalId)
            : await updateProposalGranteeBasicInfo(request, projectId, personalId)
          break
        case 'responsinator':
          response = isSubProject
            ? await updateProposalResponsinatorBasicInfoSubproject(request, projectId, personalId)
            : await updateProposalResponsinatorBasicInfo(request, projectId, personalId)
          break

        default:
          break
      }
      // console.log('type', type, 'handleUpdate response', response)
      setFormSchema(response)
      onChangeIsEdit(false)
      callbackAction()

      if (isSubProject) {
        await dispatch(getSchemaSubProjectSidebar(projectId))
      } else {
        await dispatch(getSchemaSidebar(projectId))
      }
    } catch (e) {
      console.log('e', e)
      setIsError(true)
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleSave = async (request) => {
    startLoading()
    setIsLoading(true)
    setIsError(false)
    try {
      let response

      switch (type) {
        case 'grantee':
          response = isSubProject
            ? await saveSubProjectProposalGranteeBasicInfo(request, projectId)
            : await saveProposalGranteeBasicInfo(request, projectId)
          break
        case 'responsinator':
          response = isSubProject
            ? await saveProposalResponsinatorBasicInfoSubproject(request, projectId)
            : await saveProposalResponsinatorBasicInfo(request, projectId)
          break

        default:
          break
      }
      // console.log('type', type, 'handleSave response', response)
      setFormSchema(response)
      onChangeIsEdit(false)
      callbackAction()

      if (isSubProject) {
        await dispatch(getSchemaSubProjectSidebar(projectId))
      } else {
        await dispatch(getSchemaSidebar(projectId))
      }
    } catch (e) {
      console.log('e', e)
      setIsError(true)
    }
    setIsLoading(false)
    doneLoading()
  }

  const onSubmit = (data) => {
    // console.log('onSubmit', data)
    const formData = new FormData()

    data.powerOfAttorney &&
      data.powerOfAttorney?.forEach((element) => {
        formData.append('PowerOfAttorneyFile', element.blobFile)
      })

    data.idCard &&
      data.idCard?.forEach((element) => {
        formData.append('IdCardFile', element.blobFile)
      })

    formData.append('Submission', data.submission || 0)
    formData.append('IdNumber', data.idNumber || '')
    formData.append('Honorific', data.honorific || '')
    formData.append('PersonType', data.personType || 0)
    formData.append('FirstName', data.firstName || '')
    formData.append('LastName', data.lastName || '')
    formData.append('Nationality', data.nationality || '')
    formData.append('NationalityOther', data.nationalityInputOther || '')
    formData.append('Telephone', data.telephone || '')
    formData.append('Mobile', data.mobile || '')
    formData.append('Fax', data.fax || '')
    formData.append('Email', data.email || '')
    formData.append('LineId', data.lineId || '')
    formData.append('DateOfBirth', moment(data.dateOfBirth).format('YYYY/MM/DD') || '')
    formData.append('ProjectVersionId', projectId)
    formData.append('PowerOfAttorneyDelete', data.isDeletePowerOfAttorney || false)
    formData.append('IdCardDelete', data.isDeleteIdCard || false)

    if (data.id) {
      handleUpdate(formData, data.id)
    } else {
      handleSave(formData)
    }
  }

  const handleFile = async (type, filePath, fileName) => {
    try {
      // const file = isSubProject
      //   ? await downlondSubProjectDocument(projectId, filePath)
      //   : await downlondDocument(projectId, filePath)
      const file = await downlondDocument(projectId, filePath)

      if (type == 'download') {
        downloadFile(file, fileName)
      } else {
        previewFile(file, fileName)
      }
    } catch (e) {
      setFileErr(`${type == 'download' ? 'ดาวน์โหลด' : 'แสดง'}ไฟล์ ${fileName} ไม่สำเร็จ`)
    }
  }

  return (
    <>
      <Panel
        shaded
        header={formSchema.title}
        bordered
        collapsible
        defaultExpanded
        ref={(section) => {
          setSection(section)
        }}
      >
        {formSchema?.alertMessages?.map((e) => (
          <Message
            showIcon={e.showIcon}
            type={e.type || 'warning'}
            description={e.message}
            style={{ marginBottom: 10 }}
          />
        ))}

        {isEdit && showCommandButton ? (
          <PersonalBasicInfoForm
            schema={formSchema}
            honorificOptions={honorificOptions}
            register={register}
            Controller={Controller}
            control={control}
            errors={errors}
            getValues={getValues}
            setValue={setValue}
            clearErrors={clearErrors}
            handleFile={handleFile}
            fileErr={fileErr}
            setFileErr={setFileErr}
            isSubProject={isSubProject}
            projectId={projectId}
            type={type}
            offerFundedInfoSchema={offerFundedInfoSchema}
          />
        ) : (
          <div>
            <PersonalBasicInfoView
              data={formSchema}
              handleFile={handleFile}
              fileErr={fileErr}
              setFileErr={setFileErr}
            />
          </div>
        )}

        {showCommandButton && (
          <>
            <hr />
            <ButtonPanel
              isDisabled={isLoading}
              isEdit={isEdit}
              isError={isError}
              buttonText={formSchema.buttonText || formSchema.title}
              onSave={handleSubmit(onSubmit)}
              onCancel={() => {
                setIsError(false)
                onChangeIsEdit(!isEdit)
              }}
              onEdit={() => {
                setIsError(false)
                onChangeIsEdit(!isEdit)
                scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })
              }}
            />
          </>
        )}
      </Panel>
    </>
  )
}
